export default __webpack_public_path__ + "static/media/fb.2d422469.svg";